export interface GoogleAddressComponents {
  streetNumber?: string;
  route?: string;
  locality?: string;
  administrativeAreaLevel1?: string;
  administrativeAreaLevel2?: string;
  administrativeAreaLevel3?: string;
  postalCode?: string;
}

export interface ParsedAddress {
  address1: string;
  city: string;
  province: string;
  postalCode: string;
}

export class GoogleAutoAddressCompleteUtils {
  static parseAddressComponents(result: any): ParsedAddress {
    if (!result?.address_components) {
      return {
        address1: '',
        city: '',
        province: '',
        postalCode: ''
      };
    }

    const components = this.extractComponents(result.address_components);
    
    return {
      address1: components.streetNumber 
        ? `${components.streetNumber} ${components.route}` 
        : components.route || '',
      city: components.administrativeAreaLevel3 
        || components.locality 
        || components.administrativeAreaLevel2 
        || '',
      province: components.administrativeAreaLevel1 || '',
      postalCode: components.postalCode || ''
    };
  }

  private static extractComponents(addressComponents: any[]): GoogleAddressComponents {
    const streetNumber = addressComponents.find(component =>
      component.types.includes('street_number')
    )?.long_name;

    const route = addressComponents.find(component =>
      component.types.includes('route')
    )?.long_name;

    const locality = addressComponents.find(component =>
      component.types.includes('locality')
    )?.long_name;

    const administrativeAreaLevel1 = addressComponents.find(component =>
      component.types.includes('administrative_area_level_1')
    )?.short_name;

    const administrativeAreaLevel2 = addressComponents.find(component =>
      component.types.includes('administrative_area_level_2')
    )?.long_name;

    const administrativeAreaLevel3 = addressComponents.find(component =>
      component.types.includes('administrative_area_level_3')
    )?.long_name;

    const postalCode = addressComponents.find(component =>
      component.types.includes('postal_code')
    )?.long_name;

    return {
      streetNumber,
      route,
      locality,
      administrativeAreaLevel1,
      administrativeAreaLevel2,
      administrativeAreaLevel3,
      postalCode
    };
  }
}